import { render, staticRenderFns } from "./AFTER_SALE_APPLY_ORDER.vue?vue&type=template&id=39b4d3c4&scoped=true"
import script from "./AFTER_SALE_APPLY_ORDER.vue?vue&type=script&lang=js"
export * from "./AFTER_SALE_APPLY_ORDER.vue?vue&type=script&lang=js"
import style0 from "./AFTER_SALE_APPLY_ORDER.vue?vue&type=style&index=0&id=39b4d3c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b4d3c4",
  null
  
)

export default component.exports